import React, { FC } from "react";

import { ChooseSpecialist } from "../View/ChooseSpecialist";
import { DoctorsList } from "../View/DoctorsList/DoctorsList";
import { ServicesList } from "../View/ServicesList";
import { SpecializationsContainer } from "../View/SpecializationsContainer";
import { InsuranceListParams } from "../../../Pages/InsuranceHome/InsuranceListParams.csharp";

export const ExplorePage: FC<InsuranceListParams> = (props) => {
  const {
    specializations,
    services,
    locations,
    featuredSpecializations,
    isAuthenticated,
  } = props;

  return (
    <div className="insuranceBody insuranceExplorePage">
      <SpecializationsContainer
        featuredSpecializations={featuredSpecializations}
        specializations={specializations}
      />
      <ServicesList services={services} />
      <ChooseSpecialist locations={locations} />
      <DoctorsList locations={locations} isAuthenticated={isAuthenticated} />
    </div>
  );
};
